import { Group, SimpleGrid, Stack } from '@mantine/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomModal from '.';
import ColorButton from '../Buttons/ColorButton';
import plan from '../../../../../assets/images/module/general/plan.svg';
import planBlue from '../../../../../assets/images/module/general/planBlue.svg';
import planWhite from '../../../../../assets/images/module/general/planWhite.svg';
import skyscraper from '../../../../../assets/images/module/general/skyscraper.svg';
import skyscraperBlue from '../../../../../assets/images/module/general/skyscraperBlue.svg';
import skyscraperWhite from '../../../../../assets/images/module/general/skyscraperWhite.svg';
import GoldenLockIcon from '../../../../../assets/images/module/general/GoldenLockIcon.svg';
import Autoload from '../../../../Autoload';
import accounting from 'accounting';
import { isStarterTier, isProfessionalTier } from '../../../../../helpers/subscriptionFeatureAccess';

const MOBILE_SIZE = 992;

class AddPropertyTypeModal extends Component {
    state={
        porpertyTypes: [
            {
                type: 'CONDOMINIUM'
            },
            {
                type: 'REGULAR'
            }
        ],
        hover1: false,
        hover2: false,
        selectedType: '',
        isMobile: window.innerWidth <= MOBILE_SIZE,
        addOnDetails: [],
    }
    constructor(props){
        super(props);
    }

    componentDidMount(){
        window.addEventListener('resize', this.handleResize);
        this.getSubscriptionAddOnDetails();
    }

    componentDidUpdate(prevProps){
        if(prevProps.open !== this.props.open){
            this.setState({selectedType: ''});
        }
    }

    handleResize = () => {
        if (window.innerWidth <= MOBILE_SIZE) {
          this.setState({ isMobile: true });
        } else {
          this.setState({ isMobile: false });
        }
      };

    handleMouseEnter=(type)=>{
        this.setState({[type]: true});
    }

    handleMouseLeave=(type)=>{
        this.setState({[type]: false});
    }

    getSubscriptionAddOnDetails = () => {
        const { currentSubscription } = this.props;
        console.log('currentSubscription?.subscriptionName: ', currentSubscription?.subscriptionName);
        
        if(isProfessionalTier(currentSubscription)){
            Autoload.HttpRequestAxios.HttpRequest(
                Autoload.Setting.subscription_api_baseurl + 'subscriptions/AddOn',
                'GET',
                null,
                null,
                false,
                true,
                false,
                this,
                'handleGetSubscriptionAddOnDetailsResponse',
                null,
                false,
                '',
                { 'Content-Type': 'application/json', Authorization: Autoload.Utils.getAuthToken() }
            );
        }
    }

    handleGetSubscriptionAddOnDetailsResponse(response){
        if(response.status && response.statuscode === 200){
            const addOnDetails = response.result.find((addOn) => addOn.name === 'Zusatzobjekte');
            this.setState({addOnDetails});
        }
    }

    render(){
        const { open, toggle, className, edit, next, availableNumberOfRegularProperties, availableNumberOfCondoProperties, currentSubscription, availableNumberOfAdditionalProperties, properties, hasTested} = this.props;
        const { hover1, hover2, selectedType, isMobile, addOnDetails } = this.state;
        console.log('currentSubscription: ', currentSubscription);
        const propertyLimitReached = (availableNumberOfRegularProperties - availableNumberOfAdditionalProperties) <= 0 && (availableNumberOfCondoProperties - (availableNumberOfAdditionalProperties * 5)) <= 0;
        console.log('propertyLimitReached: ', propertyLimitReached);

        console.log('properties: ', properties);
        
        const currentNumberOfRegularProperties = properties.filter(property => property.propertyType === 'REGULAR')?.length || 0;
        const currentNumberOfCondoProperties = properties.filter(property => property.propertyType === 'CONDOMINIUM')?.length || 0;

        const propertyLimitReachedForSelectedType = (selectedType === 'REGULAR' && availableNumberOfRegularProperties <= 0) || (selectedType === 'CONDOMINIUM' && availableNumberOfCondoProperties <= 0);
        const isCurrentSubscriptionProfessional = isProfessionalTier(currentSubscription);
        const propertyLimitReachedForBothTypes = !isCurrentSubscriptionProfessional && availableNumberOfRegularProperties <= 0 && availableNumberOfCondoProperties <= 0;

        const hasAvailableProperties = availableNumberOfRegularProperties > 0 || availableNumberOfCondoProperties > 0;
        const shouldRenderGroup = hasAvailableProperties || isCurrentSubscriptionProfessional;

        console.log('addOnDetails: ', addOnDetails);
        
        return(
            <CustomModal
            heading={'Mietobjekt hinzufügen'}
            headingClassName={'property-type-modal-heading'}
            open={open}
            toggle={() => {
                toggle();
            }}
            className={`${className}`}>
                <Stack>
                    {(currentSubscription && hasTested) &&
                    <>
                    <Group><span className='add-allocation-sub-headings'>Aktuelle Nutzung</span></Group>
                    <Stack>
                        <Group>
                                <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '14px'}}>Ihr aktuelles Abonnement umfasst <span style={{fontWeight: '600'}}>{(currentSubscription?.limitProperties || 0) + (isCurrentSubscriptionProfessional ? (availableNumberOfAdditionalProperties || 0) : 0)}</span> Mietobjekte{(isCurrentSubscriptionProfessional && availableNumberOfAdditionalProperties > 0) ? <span> ({currentSubscription?.limitProperties || 0} Mietobjekte inkludiert im Abonnement und {availableNumberOfAdditionalProperties} <span style={{fontWeight: 400}}>{availableNumberOfAdditionalProperties > 1 ? 'Zusatzobjekte' : 'Zusatzobjekt'}</span>)</span> : ''}. <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '14px'}}>Aktuell nutzen Sie:</span></span>
                        </Group>
                        <Stack gap={0}>
                            <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '14px'}}><span style={{fontWeight: '600'}}>{currentNumberOfRegularProperties}</span> Mehrparteienhäuser</span>
                            <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '14px'}}><span style={{fontWeight: '600'}}>{currentNumberOfCondoProperties}</span> Eigentumseinheiten</span>
                        </Stack>
                    </Stack>
                    {shouldRenderGroup && (
                    <Group>
                        {hasAvailableProperties && (
                            <span style={{ fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '12px' }}>
                                Sie können ohne Zusatzkosten noch <span style={{ fontWeight: '600' }}>{availableNumberOfRegularProperties > 0 ? availableNumberOfRegularProperties : 0}</span> Mehrparteienhäuser oder <span style={{ fontWeight: '600' }}>{availableNumberOfCondoProperties > 0 ? availableNumberOfCondoProperties : 0}</span> Eigentumseinheiten (Eigentumswohnung oder Gewerbeeinheit) anlegen.
                            </span>
                        )}
                        
                        {isCurrentSubscriptionProfessional && (
                            <span style={{ fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '12px' }}>
                                Wenn Sie darüber hinaus Mietobjekte anlegen wollen, wird hellohousing Ihr Abonnement bedarfsgerecht um Zusatzobjekte erweitern.
                            </span>
                        )}
                    </Group>)}
                    {isCurrentSubscriptionProfessional && 
                    <Group>
                        <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '12px'}}>Jedes Zusatzobjekt beinhaltet <span style={{fontWeight: '600'}}>1</span> Mehrparteienhaus oder <span style={{fontWeight: '600'}}>5</span> Eigentumseinheiten (Eigentumswohnung oder Gewerbeeinheit). Je Zusatzobjekt entstehen Kosten i.H.v. <span style={{fontWeight: '600'}}>{accounting.formatMoney(addOnDetails?.price || 0, 'EUR', 2, '.', ',', '%v %s')} / Monat</span>.</span>
                    </Group>}
                    </>}
                    {!propertyLimitReachedForBothTypes &&
                    <>
                    <Group><span className='add-allocation-sub-headings'>Mietobjekt anlegen</span></Group>
                    <Group>
                        <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '14px'}}>Bitte wählen Sie welche Art von Mietobjekt sie anlegen wollen:</span>
                    </Group>
                    <SimpleGrid cols={isMobile ? 1 : 2}>
                        <Group justify='center'
                        className={isMobile ? 'property-type-button-mobile' : 'property-type-button'}
                        onMouseEnter={()=> this.handleMouseEnter('hover2')}
                        onMouseLeave={()=> this.handleMouseLeave('hover2')}
                        onClick={()=> //availableNumberOfRegularProperties > 0 && 
                            this.setState({selectedType: 'REGULAR'})}
                        style={{
                            background: selectedType === 'REGULAR' && '#E3E3FC',
                            // cursor: availableNumberOfRegularProperties > 0 ? 'pointer' : 'not-allowed',
                            // opacity: availableNumberOfRegularProperties > 0 ? 1 : 0.5,
                        }}
                        align='flex-start'>
                            <Stack gap={'5px'}>
                                <Group justify={'space-between'} wrap="nowrap" align={isMobile && 'flex-start'}>
                                    <span style={{fontWeight: '600', fontFamily: 'Inter, sans-sarif', fontSize: '16px', color: selectedType === 'REGULAR' ? '#5555FF' : hover2 ? '#5555FF' : '#252563', wordBreak: 'break-word'}}>Mehrparteienhaus</span>
                                    <img style={{marginTop: isMobile && '3px'}} src={selectedType === 'REGULAR' ? skyscraperBlue : hover2 ? skyscraperBlue : skyscraper} width='16px' height={'16px'} />
                                </Group>
                                <span style={{textAlign: '', fontWeight: '400', color: selectedType === 'REGULAR' ? '#252563' : '#252563'}}>Sie wollen ein Mietshaus, gemischte Immobilie oder Gewerbeobjekt mit allen darin befindlichen Mieteinheiten verwalten.</span>
                            </Stack>
                        </Group>
                        <Group justify='center'
                        className={isMobile ? 'property-type-button-mobile' : 'property-type-button'}
                        onMouseEnter={()=> this.handleMouseEnter('hover1')}
                        onMouseLeave={()=> this.handleMouseLeave('hover1')}
                        onClick={()=> //availableNumberOfCondoProperties > 0 && 
                            this.setState({selectedType: 'CONDOMINIUM'})}
                        style={{
                            background: selectedType === 'CONDOMINIUM' && '#E3E3FC',
                            // cursor: availableNumberOfCondoProperties > 0 ? 'pointer' : 'not-allowed',
                            // opacity: availableNumberOfCondoProperties > 0 ? 1 : 0.5,
                        }}
                        align='flex-start'>
                            <Stack gap={'5px'}>
                                <Group justify={'space-between'} wrap="nowrap" align={isMobile && 'flex-start'}>
                                    <span style={{fontWeight: '600', fontFamily: 'Inter, sans-sarif', fontSize: '16px', color: selectedType === 'CONDOMINIUM' ? '#5555FF' : hover1 ? '#5555FF' : '#252563', wordBreak: 'break-word'}}>Eigentumseinheit</span>
                                    <img style={{marginTop: isMobile && '3px'}} src={selectedType === 'CONDOMINIUM' ? planBlue : hover1 ? planBlue : plan} width='16px' height={'16px'} />
                                </Group>
                                <span style={{textAlign: '', fontWeight: '400', color: selectedType === 'CONDOMINIUM' ? '#252563' : '#252563'}}>Sie wollen eine einzelne Eigentumswohnung oder Gewerbeeinheit verwalten.</span>
                            </Stack>
                        </Group>
                    </SimpleGrid>
                    </>}
                    {(propertyLimitReachedForSelectedType || propertyLimitReachedForBothTypes) &&
                    <Group wrap='nowrap'>
                        {!isCurrentSubscriptionProfessional &&<img src={GoldenLockIcon}/>}
                        <span style={{fontWeight: '400', fontFamily: 'Inter, sans-sarif', fontSize: '14px'}}>{isCurrentSubscriptionProfessional ? 
                            !hasTested ? 
                            <span>Sie haben die Anzahl der verfügbaren Mietobjekte im Testzeitraum erreicht. Wenn Sie weitere Mietobjekte hinzufügen wollen, wenden Sie sich bitte an den <span className='intercom-chat-link' onClick={()=> window.Intercom('showNewMessage')}>hellohousing Kundenservice</span>.</span>
                            :
                            <span>hellohousing wird Ihr Abonnement, kostenpflichtig um 1 Zusatzobjekt erweitern.</span> 
                            : 
                            <span>Schalten Sie weitere Immobilien und neue Funktionen mit hellohousing <span style={{fontWeight: 600}}>{isStarterTier(currentSubscription) ? 'Premium-Paket' : 'Professional-Paket'}</span> frei.</span>}</span>
                    </Group>}
                    <Group justify={'space-between'}>
                        <div>
                        <ColorButton
                        className="gray-btn"
                        text={'Abbrechen'}
                        onClick={toggle}
                        />
                        </div>
                        <div>
                        <ColorButton
                        className="purple-btn"
                        text={(propertyLimitReachedForSelectedType || propertyLimitReachedForBothTypes) ? ((isCurrentSubscriptionProfessional && hasTested) ? 'Bestätigen' : 'Jetzt freischalten') : 'Weiter'}
                        onClick={()=> {
                            if((propertyLimitReachedForSelectedType || propertyLimitReachedForBothTypes) && !isCurrentSubscriptionProfessional){
                                toggle();
                                this.props.history.push('/profile/yourSubscription', {newSubscription: true});
                            } else {
                                next(selectedType);
                            }
                        }}
                        disabled={((isCurrentSubscriptionProfessional && !hasTested && propertyLimitReachedForSelectedType)) || (propertyLimitReachedForBothTypes ? false : selectedType === '')}
                        />
                        </div>
                    </Group>
                </Stack>
            </CustomModal>
        )
    }

}

const actions = {
    // addPropertyData,
    // setPropertyList,
    // changeCurrentProperty,
};
const mapStateToProps = (state) => {
    return {
      propertySelected: state.generalReducer.property,
      properties: state.generalReducer.allProperties,
      profileData: state.generalReducer.profile,
      accountID: state.generalReducer.account_api_id,
      fuelTypes: state.generalReducer.fuelTypes,
      availableNumberOfCondoProperties: state.generalReducer.availableNumberOfCondoProperties,
      availableNumberOfRegularProperties: state.generalReducer.availableNumberOfRegularProperties,
      currentSubscription: state.generalReducer.currentSubscription,
      availableNumberOfAdditionalProperties: state.generalReducer.availableNumberOfAdditionalProperties,
      hasTested: state.generalReducer.hasTested,
    };
};
export default connect(mapStateToProps, actions)(AddPropertyTypeModal);